import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/24/outline';

interface Props<T> {
  options: Array<{ label: string; value: T }>;
  onOptionSelect: (value: T) => void;
  selected: T;
}

export function SingleDropdown<T>({
  options,
  onOptionSelect,
  selected,
}: Props<T>) {
  return (
    <Menu>
      <MenuButton className="rounded-xs border-grey-t-600 border px-3 py-2 text-sm hover:outline-1 -outline-offset-1 hover:outline-white data-active:outline-white data-active:outline-2 flex items-center space-x-4 group">
        <span>{String(selected)}</span>
        <ChevronDownIcon className="size-4 shrink-0 group-data-active:rotate-180 transition-all duration-150" />
      </MenuButton>
      <MenuItems
        anchor="bottom"
        className="border flex flex-col bg-background-secondary border-grey-t-800 rounded-xs text-white p-2 space-y-2 w-(--button-width) z-60"
      >
        {options.map((opt) => (
          <MenuItem>
            <button
              data-selected={opt.value === selected ? true : undefined}
              className="z-60 p-2 data-selected:bg-grey-t-800 hover:bg-grey-t-800 rounded-xs"
              onClick={() => onOptionSelect(opt.value)}
            >
              {opt.label}
            </button>
          </MenuItem>
        ))}
      </MenuItems>
    </Menu>
  );
}
